import { defaults as interactionDefaults } from "ol/interaction";
import OlInteractionDraw from "ol/interaction/Draw";
import TileLayer from 'ol/layer/Tile.js';
import OlVectorLayer from "ol/layer/Vector";
import OlFeature from "ol/Feature";
import OlPoint from "ol/geom/Point";
import TileWMS from 'ol/source/TileWMS.js';
import OlVectorSource from "ol/source/Vector";
import OlXYZ from "ol/source/XYZ";
import OlStyle from "ol/style/Style";
import OlStroke from "ol/style/Stroke";
import OlFill from "ol/style/Fill";
import OlStyleCircle from "ol/style/Circle";

export const newTileSource = function({url}) {
	return new OlXYZ({
		//crossOrigin: 'anonymous',
		url
	});
}

export const newWMSTileLayer = function({url, layers, ...props}) {
	return new TileLayer({
    ...props,
		source: new TileWMS({
			url,
			params: {'LAYERS': layers.join(","), 'TILED': true}
		})
	})
}



export const newVectorLayer = function({ name, features = [], style }) {
	let lyr = new OlVectorLayer({
		source: new OlVectorSource({
			features
		}),
		style
  });
  lyr.setProperties({
    name
  });
  return lyr;
};

type FeatureFromCoordsOptions = {name?: string; coords: [number, number]; properties?: any};
export const newPointFeatureFromCoords = function({name, coords, properties = {}}: FeatureFromCoordsOptions) {
	return new OlFeature({
		geometry: new OlPoint(coords),
    name,
    ...properties
	});
}


export const defaultInteractions = function(opts = {}) {
  return interactionDefaults(opts).getArray();
}

export const newDrawInteraction = function({ source, type, active = true }) {
  let inter = new OlInteractionDraw({
    source,
    type
  });
  !active && inter.setActive(active);
  return inter;
}

export const defaultPointStyle = function({radius = 4, fill = "#1565C0", stroke = "#404040", strokeWidth = 2} = {}) {
  return new OlStyle({
    image: new OlStyleCircle({
      fill: new OlFill({color: fill}),
      stroke: new OlStroke({color: stroke, width: strokeWidth}),
      radius: radius
    })
  });
}

